<div class="chart-container">
    <canvas [attr.id]="id">{{ chart }}</canvas>
</div>